// UI Utilities
function athleteProfileURL(potentialURL) {
    // returns a url for the athlete profile image or a placeholder
    return isDefined(potentialURL) && potentialURL.length
        ? potentialURL
        : "/images/placeholders/placeholder-user-profile.png";
}

function athleteCoverURL(potentialURL) {
    // returns a url for the athlete profile image or a placeholder
    return isDefined(potentialURL) && potentialURL.length
        ? potentialURL
        : "/images/placeholders/placeholder-user-cover.jpg";
}

function athleteProfileEl(
    athleteName,
    athleteProfileURL,
    imgSize,
    includeName
) {
    // imgSize can be a pixel, or 'width-100' (%) or 'height-100' (%)
    var h, w, lh;
    if (imgSize === "height-100") {
        h = "100%";
        w = "auto";
        lh = "50%";
    } else if (imgSize === "width-100") {
        h = "auto";
        w = "100%";
        lh = "50%";
    } else {
        h = (imgSize || 28) + "px";
        w = h;
        lh = h;
    }

    var athEl = $('<div class="athlete-profile">');

    // profile image or initials
    if (athleteProfileURL && athleteProfileURL.length) {
        athEl.append(
            $('<img class="athlete-profile-img">')
                .prop({
                    src: athleteProfileURL,
                })
                .css({
                    height: h,
                    width: w,
                })
        );
    } else {
        var athInitials = (athleteName || "").match(/(\s|^)([a-z])/gi);
        var athDisplay = athInitials
            ? athInitials.join("").replace(/\s/g, "").toUpperCase()
            : "!";

        var colorIdx = (athleteName || "??").length % 6;
        athEl.append(
            $('<div class="athlete-initials">')
                .css({
                    height: h,
                    width: w,
                    "font-size": imgSize * 0.5 + "px",
                    "line-height": lh,
                })
                .addClass("athlete-profile-color-" + colorIdx)
                .text(athDisplay)
        );
    }

    var el;
    if (includeName) {
        el = $("<div>")
            .append(athEl)
            .append($("<span class='m-l-sm'>").text(athleteName));
    } else {
        el = athEl;
    }

    return el;
}

function athleteProfileAsHTML(
    athleteName,
    athleteProfileURL,
    imgSize,
    includeName,
    clickToAthleteId
) {
    var el = athleteProfileEl(
        athleteName,
        athleteProfileURL,
        imgSize,
        includeName
    );

    if (clickToAthleteId) {
        var e = $("<a>")
            .attr("onclick", "goAthlete('" + clickToAthleteId + "')")
            .append(el);
        return e[0].outerHTML;
    } else {
        return el[0].outerHTML;
    }
}

// IDs
function uuidv4() {
    // a reasonable facsimile of a uuid, good enough for local unique identifiers...
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}

function slugify(string) {
    const a =
        "àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;";
    const b =
        "aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");

    return string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
}

// UI HELPERS
function promptSelectTrack(tracks, prompt, callback) {
    var inputOptions = _.map(tracks, function (track) {
        return {
            text: track.name,
            value: track.id,
        };
    });

    bootbox.prompt({
        title: prompt,
        inputType: "select",
        inputOptions: inputOptions,
        callback: function (result) {
            if (result === null) return;
            callback(_.indexBy(tracks, "id")[result]);
        },
    });
}

function algoliaAffiliateLocationToString(obj) {
    var city = obj.city || "";
    var state = obj.state || "";
    var country = obj.country || "";
    var isUSA =
        ["usa", "u.s.", "us", "u.s", "america", "united states"].indexOf(
            country.toLowerCase()
        ) !== -1;

    // always show city...
    var loc = "";
    if (city.length) {
        loc = city;
    }

    // show state only if USA...
    if (isUSA && state.length) {
        if (loc.length) {
            loc += ", ";
        }
        loc += state;
    }

    // show country only if not USA...
    if (!isUSA && country.length) {
        if (loc.length) {
            loc += ", ";
        }
        loc += country;
    }

    return loc;
}

function displayTrack(trackName) {
    return trackName === _SugarWOD.constants.workout_of_the_day.id
        ? _SugarWOD.constants.workout_of_the_day.display
        : trackName;
}

// DISPLAY
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function numberFormatted(num, decimals, prefix) {
    // num: number
    // decimals: num of decimal places to display (optional)
    // prefix: string (optional)

    // example: numberFormatted(100, 2, '$") returns '$100.00'

    return (
        (prefix || "") +
        (num || 0).toFixed(decimals || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );
}

function formatSeconds(seconds) {
    // 321 -> '5:21'

    var formatStr = seconds >= 3600 ? "h:mm:ss" : "m:ss";
    return moment().startOf("day").seconds(seconds).format(formatStr);
}

function percentString(prev, cur) {
    // no change from 0 to 0
    if (prev === 0 && cur === 0) return "0%";

    if (prev === 0) return "infinite";

    var percent = (((cur - prev) / prev).toFixed(2) * 100).toFixed(0);

    if (percent === 0) return "0%";

    return (percent > 0 ? "+" : "-") + percent + "%";
}

function toCapitalize(str) {
    if (!str || !str.length) {
        return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

function toCapitalizeAllWords(string) {
    if (!(string && string.length)) return string;
    return _.map(string.trim().split(" "), function (word) {
        return toCapitalize(word);
    }).join(" ");
}

function stringReplaceCorrectCrossFitSpelling(string) {
    if (!(string && string.length)) return string;
    return string.replace(/crossfit/gi, "CrossFit");
}

// NUMBERS
function roundUpNearest(num, nearest) {
    // 62,15 -> 75
    return num + nearest - (num % nearest);
}

function roundDownNearest(num, nearest) {
    // 62,15 -> 60
    // 59,15 -> 45
    return num - (num % nearest);
}

function oom(n) {
    // return the order of magnitude
    // 4 -> 1
    // 42 -> 10
    // 420 -> 100
    var order = Math.floor(Math.log(n) / Math.LN10 + 0.000000001); // because float math sucks like that
    return Math.pow(10, order);
}

function filterOutliers(someArray) {
    // http://stackoverflow.com/questions/20811131/javascript-remove-outlier-from-an-array

    // Copy the values, rather than operating on references to existing values
    var values = someArray.concat();

    // Then sort
    values.sort(function (a, b) {
        return a - b;
    });

    /* Then find a generous IQR. This is generous because if (values.length / 4)
     * is not an int, then really you should average the two elements on either
     * side to find q1.
     */
    var q1 = values[Math.floor(values.length / 4)];
    // Likewise for q3.
    var q3 = values[Math.ceil(values.length * (3 / 4))];
    var iqr = q3 - q1;

    // Then find min and max values
    var maxValue = q3 + iqr * 1.5;
    var minValue = q1 - iqr * 1.5;

    // Then filter anything beyond or beneath these values.
    var filteredValues = values.filter(function (x) {
        return x < maxValue && x > minValue;
    });

    // Then return
    return filteredValues;
}

function runningTotal(anArray) {
    // http://stackoverflow.com/questions/11890897/how-to-obtain-cumulative-sum-array-using-underscore-js
    return _.reduce(
        anArray,
        function (acc, n) {
            acc.push((acc.length > 0 ? acc[acc.length - 1] : 0) + n);
            return acc;
        },
        []
    );
}

// FLASH MESSAGES
function showFlash(type, messageTitle, messageDetail) {
    // http://codeseven.github.io/toastr/demo.html
    //
    // types = success, info, warning, error

    /* global toastr */
    toastr[type](messageDetail, messageTitle);
}

function showFlashSuccess(messageTitle, messageDetail) {
    showFlash("success", messageTitle, messageDetail);
}

function showFlashInfo(messageTitle, messageDetail) {
    showFlash("info", messageTitle, messageDetail);
}

function showFlashError(messageTitle, messageDetail) {
    showFlash("error", messageTitle, messageDetail);
}

// MISC
function initializeTooltips(el) {
    if (el) {
        $('[data-toggle="tooltip"]', el).tooltip();
    } else {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    }
}

function getParams(param) {
    const urlParamValue = new URLSearchParams(window.location.search).get(
        param
    );
    return urlParamValue;
}

module.exports = {
    athleteProfileURL,
    athleteCoverURL,
    athleteProfileEl,
    athleteProfileAsHTML,
    uuidv4,
    slugify,
    promptSelectTrack,
    algoliaAffiliateLocationToString,
    displayTrack,
    numberWithCommas,
    numberFormatted,
    formatSeconds,
    percentString,
    toCapitalize,
    toCapitalizeAllWords,
    stringReplaceCorrectCrossFitSpelling,
    roundUpNearest,
    roundDownNearest,
    oom,
    filterOutliers,
    runningTotal,
    showFlash,
    showFlashSuccess,
    showFlashInfo,
    showFlashError,
    initializeTooltips,
    getParams,
};
